import React, { useState, useEffect } from "react"
import Header from "../components/Header"
import { Tabs } from "antd"
import ReactGA from "react-ga4"

import Footer from "../components/Footer"
import ImageBanner from "../components/ImageBanner"
import MarkdownContent from "../components/MarkdownContent"

import content from "../data/pageContent.json"
import s from "./SchoolZone.module.css"

const AirQualityAdvice = (props) => {
  const [tabSelection, setTabSelection] = useState({
    main: "health",
    health: "why-air-pollution-is-bad-for-health",
    outside: "check-air-quality",
    inside: "damp-and-mould",
    resources: "why-this-matters",
  })

  const page = content["air-quality-advice"]

  useEffect(() => {
    document.title = page["page-title"]
    window.scrollTo(0, 0)
    const cookies = JSON.parse(localStorage.getItem("cookiePreferences"))
    if (cookies?.accepted) {
      ReactGA.send({ hitType: "pageview", page: window.location.pathname })
    }
  }, [page])

  const handleMainTab = (e) => {
    setTabSelection({ ...tabSelection, main: e })
  }

  const handleHealthTab = (e) => {
    setTabSelection({ ...tabSelection, health: e })
  }

  const handleOutsideTab = (e) => {
    setTabSelection({ ...tabSelection, outside: e })
  }

  const handleInsideTab = (e) => {
    setTabSelection({ ...tabSelection, inside: e })
  }

  const handleResourcesTab = (e) => {
    setTabSelection({ ...tabSelection, resources: e })
  }

  const healthWhyAirPollutionIsBadForHealth =
    tabSelection.main === "health" &&
    tabSelection.health === "why-air-pollution-is-bad-for-health"
  const healthWhoIsAffected =
    tabSelection.main === "health" && tabSelection.health === "who-is-affected"
  const healthEffectsOfAirPollution =
    tabSelection.main === "health" &&
    tabSelection.health === "health-effects-of-air-pollution"
  const healthReducingYourExposure =
    tabSelection.main === "health" &&
    tabSelection.health === "reducing-your-exposure"

  const outsideCheckAirQuality =
    tabSelection.main === "outside" &&
    tabSelection.outside === "check-air-quality"
  const outsideAvoidBusyRoads =
    tabSelection.main === "outside" &&
    tabSelection.outside === "avoid-busy-roads"
  const outsideAvoidPeakHour =
    tabSelection.main === "outside" &&
    tabSelection.outside === "avoid-peak-hour"
  const outsideLeaveCarAtHome =
    tabSelection.main === "outside" &&
    tabSelection.outside === "leave-car-at-home"
  const outsideSwitchOffEngine =
    tabSelection.main === "outside" &&
    tabSelection.outside === "switch-off-engine"
  const insideDampAndMould =
    tabSelection.main === "inside" && tabSelection.inside === "damp-and-mould"
  const insideImproveVentilation =
    tabSelection.main === "inside" &&
    tabSelection.inside === "improve-ventilation"
  const insideDayToDayProducts =
    tabSelection.main === "inside" &&
    tabSelection.inside === "day-to-day-products"
  const insideHomeBurning =
    tabSelection.main === "inside" && tabSelection.inside === "home-burning"

  const insidePetDander =
    tabSelection.main === "inside" && tabSelection.inside === "pet-dander"
  const insideBeneficialPlants =
    tabSelection.main === "inside" &&
    tabSelection.inside === "beneficial-plants"

  const resourcesWhyThisMatters =
    tabSelection.main === "resources" &&
    tabSelection.resources === "why-this-matters"

  const resourcesToSupportYou =
    tabSelection.main === "resources" &&
    tabSelection.resources === "resources-to-support-you"

  const resourcesForThePublicAndPatients =
    tabSelection.main === "resources" &&
    tabSelection.resources === "resources-for-the-public-and-patients"

  const resourcesAboutThisProgramme =
    tabSelection.main === "resources" &&
    tabSelection.resources === "about-this-programme"

  return (
    <main>
      <ImageBanner
        wide={true}
        title={page.title}
        subtitle={page.subtitle}
        image={page.image}
      />

      <Header
        image={page.image}
        wide={true}
        title={page.title}
        subtitle={page.subtitle}
      >
        <Tabs
          centered
          size={"large"}
          className={s.tabs}
          defaultActiveKey="health"
          onChange={handleMainTab}
          items={[
            {
              label: `Air quality and health`,
              key: "health",
              children: (
                <Tabs
                  centered
                  size={"large"}
                  className={s.tabs}
                  defaultActiveKey="why-air-pollution-is-bad-for-health"
                  onChange={handleHealthTab}
                  items={[
                    {
                      label: `Why air pollution is bad for health`,
                      key: "why-air-pollution-is-bad-for-health",
                      children: <></>,
                    },
                    {
                      label: `Who is affected`,
                      key: "who-is-affected",
                      children: <></>,
                    },
                    {
                      label: `Health effects of air pollution`,
                      key: "health-effects-of-air-pollution",
                      children: <></>,
                    },
                    {
                      label: `Reducing your exposure`,
                      key: "reducing-your-exposure",
                      children: <></>,
                    },
                  ]}
                />
              ),
            },
            {
              label: `Air pollution inside the home`,
              key: "inside",
              children: (
                <Tabs
                  centered
                  size={"large"}
                  className={s.tabs}
                  defaultActiveKey="damp-and-mould"
                  onChange={handleInsideTab}
                  items={[
                    {
                      label: `Damp and mould`,
                      key: "damp-and-mould",
                      children: <></>,
                    },
                    {
                      label: `Improve ventilation`,
                      key: "improve-ventilation",
                      children: <></>,
                    },
                    {
                      label: `Day-to-day products`,
                      key: "day-to-day-products",
                      children: <></>,
                    },
                    {
                      label: `Home burning`,
                      key: "home-burning",
                      children: <></>,
                    },
                    {
                      label: `Pet dander`,
                      key: "pet-dander",
                      children: <></>,
                    },
                    {
                      label: `Beneficial plants`,
                      key: "beneficial-plants",
                      children: <></>,
                    },
                  ]}
                />
              ),
            },
            {
              label: `Air pollution outside the home`,
              key: "outside",
              children: (
                <Tabs
                  centered
                  size={"large"}
                  className={s.tabs}
                  defaultActiveKey="check-air-quality"
                  onChange={handleOutsideTab}
                  items={[
                    {
                      label: `Check local air quality`,
                      key: "check-air-quality",
                      children: <></>,
                    },
                    {
                      label: `Avoid busy roads`,
                      key: "avoid-busy-roads",
                      children: <></>,
                    },
                    {
                      label: `Avoid peak time travel`,
                      key: "avoid-peak-hour",
                      children: <></>,
                    },
                    {
                      label: `Leave the car at home`,
                      key: "leave-car-at-home",
                      children: <></>,
                    },
                    {
                      label: `Switch off your engine`,
                      key: "switch-off-engine",
                      children: <></>,
                    },
                  ]}
                />
              ),
            },
            {
              label: `Resources for health and social care professionals`,
              key: "resources",
              children: (
                <Tabs
                  centered
                  size={"large"}
                  className={s.tabs}
                  defaultActiveKey="why-this-matters"
                  onChange={handleResourcesTab}
                  items={[
                    {
                      label: `Why this matters`,
                      key: "why-this-matters",
                      children: <></>,
                    },
                    {
                      label: `Resources to support you`,
                      key: "resources-to-support-you",
                      children: <></>,
                    },
                    {
                      label: `Resources for the public and patients`,
                      key: "resources-for-the-public-and-patients",
                      children: <></>,
                    },
                    {
                      label: `About this programme`,
                      key: "about-this-programme",
                      children: <></>,
                    },
                  ]}
                />
              ),
            },
          ]}
        />
      </Header>

      <div className={"body"}>
        <div className={"body-container"}>
          <div className="markdown-wrapper">
            {healthWhyAirPollutionIsBadForHealth && (
              <section>
                <h3 className={"section-header-short"}>
                  Why air pollution is bad for health
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/why-air-pollution-is-bad-for-health" />
              </section>
            )}

            {healthWhoIsAffected && (
              <section>
                <h3 className={"section-header-short"}>Who is affected</h3>
                <MarkdownContent pathname="/airQualityAdvice/who-is-affected" />
              </section>
            )}

            {healthEffectsOfAirPollution && (
              <section>
                <h3 className={"section-header-short"}>
                  Health effects of air pollution
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/health-effects-of-air-pollution" />
              </section>
            )}

            {healthReducingYourExposure && (
              <section>
                <h3 className={"section-header-short"}>
                  Reducing your exposure
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/reducing-your-exposure" />
              </section>
            )}

            {outsideCheckAirQuality && (
              <section>
                <h3 className={"section-header-short"}>
                  Check the air pollution in your area
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/check-local-air-quality" />
              </section>
            )}
            {outsideAvoidBusyRoads && (
              <section>
                <h3 className={"section-header-short"}>
                  Choose to walk, wheel or cycle away from busy roads
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/avoid-busy-roads" />
              </section>
            )}

            {outsideAvoidPeakHour && (
              <section>
                <h3 className={"section-header-short"}>
                  Avoid travelling at busy times of day
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/avoid-peak-time-travel" />
              </section>
            )}

            {outsideLeaveCarAtHome && (
              <section>
                <h3 className={"section-header-short"}>
                  Leave the car at home whenever you can
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/leave-the-car-at-home" />
              </section>
            )}

            {outsideSwitchOffEngine && (
              <section>
                <h3 className={"section-header-short"}>
                  Switch off your engine when waiting
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/switch-off-engine" />
              </section>
            )}

            {insideDampAndMould && (
              <section>
                <h3 className={"section-header-short"}>
                  Tackle damp and mould
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/damp-and-mould" />
              </section>
            )}

            {insideImproveVentilation && (
              <section>
                <h3 className={"section-header-short"}>
                  Ventilate to let pollution from every day activities escape
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/improve-ventilation" />
              </section>
            )}

            {insideDayToDayProducts && (
              <section>
                <h3 className={"section-header-short"}>
                  Cut down use of aerosols, sprays and scented products
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/day-to-day-products" />
              </section>
            )}

            {insideHomeBurning && (
              <section>
                <h3 className={"section-header-short"}>
                  Avoid unnecessary burning
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/home-burning" />
              </section>
            )}
            {insidePetDander && (
              <section>
                <h3 className={"section-header-short"}>Pet dander</h3>
                <MarkdownContent pathname="/airQualityAdvice/pet-dander" />
              </section>
            )}
            {insideBeneficialPlants && (
              <section>
                <h3 className={"section-header-short"}>Beneficial plants</h3>
                <MarkdownContent pathname="/airQualityAdvice/beneficial-plants" />
              </section>
            )}

            {resourcesWhyThisMatters && (
              <section>
                <h3 className={"section-header-short"}>Why this matters</h3>
                <MarkdownContent pathname="/airQualityAdvice/why-this-matters" />
              </section>
            )}

            {resourcesToSupportYou && (
              <section>
                <h3 className={"section-header-short"}>
                  Resources to support you
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/resources-to-support-you" />
              </section>
            )}

            {resourcesForThePublicAndPatients && (
              <section>
                <h3 className={"section-header-short"}>
                  Resources for the public and patients
                </h3>
                <MarkdownContent pathname="/airQualityAdvice/resources-for-the-public-and-patients" />
              </section>
            )}

            {resourcesAboutThisProgramme && (
              <section>
                <h3 className={"section-header-short"}>About this programme</h3>
                <MarkdownContent pathname="/airQualityAdvice/about-this-programme" />
              </section>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default AirQualityAdvice

// const resourcesWhyThisMatters =
//   tabSelection.main === "resources" &&
//   tabSelection.inside === "why-this-matters"

// const resourcesToSupportYou =
//   tabSelection.main === "resources" &&
//   tabSelection.inside === "resources-to-support-you"

// const resourcesForThePublicAndPatients =
//   tabSelection.main === "resources" &&
//   tabSelection.inside === "resources-for-the-public-and-patients"

// const resourcesAboutThisProgramme =
//   tabSelection.main === "resources" &&
//   tabSelection.inside === "about-this-programme"
